import {Alert, Div, HeaderBack, TabViewComp} from 'components';
import {Ecolors} from 'constant';
import React, {useCallback, useRef, useState} from 'react';
import HistoryTransaction from './HistoryTransaction';
import OrderTransaction from './OrderTransaction';
import AutoInvestTranasction from './AutoInvestTranasction';
import {useFocusEffect, useRoute} from '@react-navigation/native';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {apiTransaction} from 'services/apis/apiTransaction';
import {navigate, navigationRef} from 'services';

function TransactionScreen() {
  const dispatch = useAppDispatch();
  const route = useRoute<any>();
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const tabRef = useRef<{goTo: (i: number) => void}>(null);

  useFocusEffect(
    useCallback(() => {
      const initPage = route?.params?.initPage;

      if (initPage !== undefined) {
        tabRef.current?.goTo(initPage);
        focusToSipDetails({
          sipSchemeId: route?.params?.sipSchemeId,
        });
      }
    }, [route?.params]),
  );

  const focusToSipDetails = async ({sipSchemeId}) => {
    try {
      const res = await apiTransaction.getAutoInvestDetails({
        orderId: sipSchemeId,
      });
      if (res.status == 200) {
        setTimeout(() => {
          navigate('AutoInvestOrderDetailsModal', {
            data: res.data?.[0],
          });
        }, 500);
      }
    } catch (error: any) {
      Alert.showError({
        multilanguage: false,
        content: I18nState == 'vi' ? error.message : error.messageEn,
      });
    }
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack title={`transactionscreen.giaodich`} />
      <TabViewComp
        ref={tabRef}
        onChange={e => {
          if (e == 1) {
            // controlLoadHistory();
          }
        }}
        multilanguage={true}
        data={[
          {
            Component: OrderTransaction,
            title: `transactionscreen.lenhchoxuly`,
            key: 'OrderTransaction',
          },
          {
            Component: HistoryTransaction,
            title: `transactionscreen.lichsugiaodich`,
            key: 'HistoryTransaction',
          },
          {
            Component: AutoInvestTranasction,
            title: `transactionscreen.dinhky`,
            key: 'AutoInvestTranasction',
          },
          // {
          //   component: (a: any) => <Statement {...a} />,
          //   title: `transactionscreen.saokegiaodich`,
          //   key: 'Statement',
          // },
        ]}
      />
    </Div>
  );
}

export default React.memo(TransactionScreen);
